// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--qcnNf","Logo":"Logo--1kzy3","Sider":"Sider--2xjoQ"};